import { Configuration } from "@azure/msal-browser"
import { LocalStorageKeys } from "./utils/local-storage-keys"

export interface IConfiguration {
  [LocalStorageKeys.BLOB_STORAGE]: string
  [LocalStorageKeys.B2C_CONFIGURATION]: Configuration
  [LocalStorageKeys.AUTHENTICATION_PARAMETERS]: { scopes: string[] }
  [LocalStorageKeys.LOADED]: boolean
}

const configuration: IConfiguration = {
  [LocalStorageKeys.B2C_CONFIGURATION]: {
    auth: {
      authority:
        "https://bruneaudroopy.b2clogin.com/bruneaudroopy.onmicrosoft.com/B2C_1_2021_SignIn",
      clientId: "7ac2dc52-b97f-44cc-8915-524ee0050425",
      redirectUri: window.location.origin,
      knownAuthorities: [
        "bruneaudroopy.b2clogin.com",
        "bruneaudroopy.onmicrosoft.com",
      ],
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  },
  [LocalStorageKeys.AUTHENTICATION_PARAMETERS]: {
    scopes: [
      "https://bruneaudroopy.onmicrosoft.com/services/user_impersonation",
    ],
  },
  [LocalStorageKeys.BLOB_STORAGE]:
    "https://sagsssmdroopydevne.blob.core.windows.net/droopycontainer",
  [LocalStorageKeys.LOADED]: true,
}

export const putConfInLocalStorage = (
  conf: IConfiguration = configuration
): void => {
  window.localStorage.setItem(
    LocalStorageKeys.B2C_CONFIGURATION,
    JSON.stringify(conf[LocalStorageKeys.B2C_CONFIGURATION])
  )
  window.localStorage.setItem(
    LocalStorageKeys.AUTHENTICATION_PARAMETERS,
    JSON.stringify(conf[LocalStorageKeys.AUTHENTICATION_PARAMETERS])
  )
  window.localStorage.setItem(
    LocalStorageKeys.BLOB_STORAGE,
    conf[LocalStorageKeys.BLOB_STORAGE]
  )
  window.localStorage.setItem(LocalStorageKeys.LOADED, "true")
}

export const initConfig = (): Promise<IConfiguration> => {
  console.log("BIAATCH")
  console.log(process.env.NODE_ENV)
  if (process.env.NODE_ENV === "production") {
  console.log(process.env.NODE_ENV)
    return fetch(window.location.origin + "/ClientApp/buildConfig/config.json")
      .then((body) => body.json())
      .then((conf: IConfiguration) => {
        conf[LocalStorageKeys.AUTHENTICATION_PARAMETERS].scopes = JSON.parse(
          // @ts-ignore
          conf[LocalStorageKeys.AUTHENTICATION_PARAMETERS].scopes || "[]"
        )

        conf[LocalStorageKeys.B2C_CONFIGURATION].auth.knownAuthorities =
          JSON.parse(
            // @ts-ignore
            conf[LocalStorageKeys.B2C_CONFIGURATION].auth.knownAuthorities ||
              "[]"
          )
        conf[LocalStorageKeys.B2C_CONFIGURATION].auth.redirectUri =
          window.location.origin
        conf[LocalStorageKeys.B2C_CONFIGURATION].auth.postLogoutRedirectUri =
          window.location.origin
        return conf
      })
      .then((conf: IConfiguration) => {
        putConfInLocalStorage(conf)
        return conf
      })
  } else {
  console.log("BIAATCH1")
    return Promise.resolve(configuration)
  }
}

export const getConfiguration = (): IConfiguration => {
  if (process.env.NODE_ENV === "production") {
    const B2C = window.localStorage.getItem(LocalStorageKeys.B2C_CONFIGURATION)
    const AUTH = window.localStorage.getItem(
      LocalStorageKeys.AUTHENTICATION_PARAMETERS
    )
    const BLOB = window.localStorage.getItem(LocalStorageKeys.BLOB_STORAGE)
    const LOADED = window.localStorage.getItem(LocalStorageKeys.LOADED)
    if (B2C === null || BLOB === null || LOADED === null || AUTH === null) {
      throw new Error(
        "Config has not been initialized, localstorage is empty !"
      )
    }
    return {
      [LocalStorageKeys.B2C_CONFIGURATION]: JSON.parse(B2C),
      [LocalStorageKeys.AUTHENTICATION_PARAMETERS]: JSON.parse(AUTH),
      [LocalStorageKeys.BLOB_STORAGE]: BLOB,
      [LocalStorageKeys.LOADED]: JSON.parse(LOADED),
    }
  } else {
  console.log("BIAATCH2")
    
    return configuration
  }
}

export const getConfigurationItem = (
  item: LocalStorageKeys
): string | Configuration | boolean | { scopes: string[] } => {
  if (process.env.NODE_ENV === "production") {
    if (
      [
        LocalStorageKeys.B2C_CONFIGURATION,
        LocalStorageKeys.AUTHENTICATION_PARAMETERS,
      ].includes(item)
    ) {
      const result = window.localStorage.getItem(item)
      return JSON.parse(result || "")
    } else {
      return window.localStorage.getItem(item) || ""
    }
  } else {
  console.log("BIAATCH3")
    
    return configuration[item]
  }
}
